import { Drawer, Loading } from "@components";
import { Titles } from "../../variables/Titles";

import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import { useEffect, useState } from "react";
import FixedValueForm from "../types/FixedValueForm";

export const OrderOriginSaleForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const [origins, setOrigins] = useState([]);
  const [loading, setLoading] = useState([]);

  const getSourceName = (sources, sourceAlias) => {
    const source = sources.find((s) => s.alias == sourceAlias);
    return source ? source.name : "Desconhecido";
  };

  const loadSources = async () => {
    setLoading(true);

    //Carrega o nome das fontes
    const sources_response = await OlgaEnvironmentsAPI.getAvailableSources();
    const sources = sources_response.getData([]);

    //Carrega as origens das fontes
    const origins_response = await OlgaEnvironmentsAPI.getExternalSourcesConfigs();
    const origin_list = origins_response.getData({});

    const _list = [];
    const external_sources_entries = Object.entries(origin_list);

    for (const [external_source, _origins] of external_sources_entries) {
      const source_name = getSourceName(sources, external_source);
      for (const [_origin, config] of Object.entries(_origins)) {
        _list.push({
          label: `${source_name} / ${config.correct || _origin} (${_origin})`,
          value: _origin,
        });
      }
    }

    setOrigins(_list);
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      loadSources();
    }
  }, [visible]);

  const loading_style = {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderOriginSale}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      {loading ? (
        <div style={loading_style}>
          <Loading />
        </div>
      ) : (
        <FixedValueForm
          node={node}
          options={origins}
          onSave={(node) => onSave(node)}
          onRemove={onRemove}
        />
      )}
    </Drawer>
  );
};
